import React from 'react';
import PropTypes from 'prop-types';
import MultipleChoiceQuestion from '../components/MultipleChoiceQuestion';

const answerOptions = [
  {id: 1, label: 'Self Managed'},
  {id: 2, label: 'Plan Managed'},
  {id: 3, label: 'Agency Managed'},
  {id: 4, label: 'Unsure'},
];

const ParticipantManagementQuestion = ({data, handleAnswer}) => {
  return (
    <MultipleChoiceQuestion
      question="How is this person's NDIS plan managed?"
      item="management_type"
      data={data}
      answerOptions={answerOptions}
      handleAnswer={handleAnswer}
    />
  );
};

ParticipantManagementQuestion.propTypes = {
  data: PropTypes.object.isRequired,
  handleAnswer: PropTypes.func.isRequired,
};

export default ParticipantManagementQuestion;
